export var PIXELENTRY_MIGRATION_BUTTON_TESTID = 'pixel-entry-convert-pixels-btn';

// pixel resizing toolbar width (with `platform_editor_controls` enabled)
export var PIXEL_RESIZING_TOOLBAR_WIDTH = 240;
export var PIXEL_VIEW_MODE_TOOLBAR_WIDTH = 204;